var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.5 15h-13a1.5 1.5 0 01-1.281-2.28L6.902 1.644a1.26 1.26 0 012.256.122l6.618 10.945A1.5 1.5 0 0114.5 15zM9 12a1 1 0 10-2 0 1 1 0 002 0zm0-6a1 1 0 00-2 0v3a1 1 0 002 0V6z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC41IDE1aC0xM2ExLjUgMS41IDAgMCAxLTEuMjgxLTIuMjhMNi45MDIgMS42NDRhMS4yNiAxLjI2IDAgMCAxIDIuMjU2LjEyMmw2LjYxOCAxMC45NDVBMS41IDEuNSAwIDAgMSAxNC41IDE1ek05IDEyYTEgMSAwIDEgMC0yIDAgMSAxIDAgMCAwIDIgMHptMC02YTEgMSAwIDAgMC0yIDB2M2ExIDEgMCAwIDAgMiAwVjZ6Ii8+Cjwvc3ZnPgo=";
export { SvgWarningTriangle as ReactComponent };